import { Component } from '@angular/core';
import { ModalService } from '../../../shared/components/modal/modal.service';
import { AbstractModal } from '../../../shared/components/modal/AbstractModal';

@Component({
  selector: 'ls-closing-report-help-modal',
  templateUrl: './closing-report-help-modal.component.html'
})
export class ClosingReportHelpModalComponent extends AbstractModal {
  constructor(private modal: ModalService) {
    super();
  }

  public close(): void {
    this.modal.close();
  }
}
